const it = {
  common: {
    role: {
      ADMIN: "Super admin",
      TENANT_ADMIN: "Admin",
      OPERATOR: "Operatore",
      PM: "Project manager",
      MACHINE: "Macchina",
    },
    action: {
      close: "Chiudi",
      add: "Nuovo",
      edit: "Modifica",
      delete: "Elimina",
      cancel: "Annulla",
      save: "Salva",
      print: "Stampa",
      confirm: "Conferma",
      select: "Seleziona",
      assign: "Assegna",
      view: "Visualizza",
      yes: "Si",
      no: "No",
      download: "Download",
      reset: "Cancella",
      new: "Crea",
      copy: "Copia",
    },
    table: {
      delete: "elimina",
      deleteRows: "Elimina %length% righe",
      add: "Nuovo",
      edit: "modifica",
      close: "chiudi",
      refresh: "ricarica",
      noRowsLabel: "Nessun dato da visualizzare",
    },
    label: {
      loading: "Caricamento",
      asset: "Asset",
      name: "Nome",
      type: "Tipo",
      createdAt: "Creato il",
      from: "da",
      for: "per",
      all: "Tutti",
      documents: "Documenti",
      start: "Inizio",
      end: "Fine",
      releaseHere: "Rilascia ",
      clickOrDrag: "Clicca o trascina un file",
      inputSearch: {
        name: "Nome",
        createdAt: "Data creazione",
      },
      tag: "Tag",
      value: "Valore",
      empty: {
        assets: "Non hai creato nessun asset",
        documents: "Nessun documento da visualizzare",
        sensors: "Non ci sono sensori nei tuoi assets",
        tickets: "Nessun ticket da visualizzare",
        artifacts: "Nessuna produzione da visualizzare",
        events: "Nessun evento da visualizzare",
      },
      next: "Avanti",
      back: "Indietro",
      yes: "Si",
      no: "No",
    },
  },
  drawer: {
    dashboard: "Dashboard",
    assets: "Asset",
    archive: "Archivio",
    monitoring: "Monitoraggio",
    users: "Utenti",
    groups: "Gruppi",
    tenants: "Aziende",
    documents: "Documenti",
    configuration: "Configurazione",
    insights: "Insights",
    audits: "Registro",
    tickets: "Tickets",
    tasks: "Attività",
    prognosis: "Prognosi",
    diagnosis: "Diagnosi",
    artifacts: "Produzioni",
    checklist: "Checklist",
    divider: "Divisore",
    tags: "Tags",
    goods: "Merci e rifiuti",
    calls: "Chiamate",
    admin: "Amministrazione",
  },
  deleteDialog: {
    title: "Elimina",
    text: "Sei sicuro di voler procedere con la cancellazione?",
    confirm: "Conferma",
    cancel: "Annulla",
  },
  form: {
    edit: "Modifica",
    new: "Nuovo",
    reset: "Reset",
    save: "Salva",
  },
  paginator: {
    rowsPerPage: "Righe",
    of: "di",
  },
  calendar: {
    date: "Data",
    time: "Ora",
    event: "Evento",
    allDay: "Tutto il giorno",
    week: "Settimana",
    work_week: "Settimana lavorativa",
    day: "Giorno",
    month: "Mese",
    previous: "Precedente",
    next: "Successivo",
    yesterday: "Ieri",
    tomorrow: "Domani",
    today: "Oggi",
    agenda: "Agenda",
    noEventsInRange: "Nessun evento in questo periodo",
    until: "fino alle",
  },
  pages: {
    login: {
      text: "Accedi a Predimain",
      username: "Username",
      password: "Password",
      rememberMe: "Ricordami",
      login: "Accedi",
    },
    tenants: {
      clearDisk: "Pulisci disco",
      clearData: "Pulisci dati",
      clearDataDescription:
        "Questa operazione eliminerà tutti i dati delle misure raccolte dell'azienda selezionata. Sei sicuro di voler procedere?",
      clearDiskDescription:
        "Questa operazione eliminerà tutti i documenti presenti sul disco dell'azienda selezionata. Sei sicuro di voler procedere?",
    },
    home: {
      addTask: {
        title: "Pianifica le tue attività",
        description:
          "Schedula i piani di manutenzione preventiva sugli asset corporativi, definisci finestre temporali e assegna il personale tecnico qualificato",
      },
      addArtifact: {
        title: "Produzione",
        description:
          "Pianifica le tue commesse e la produzione su diagramma di Gantt. Struttura i task, imposta le dipendenze temporali e controlla le risorse per ogni artefatto.",
      },
      addTicket: {
        title: "Gestione tickets",
        description:
          "Gestisci le segnalazioni tue e degli utenti, assegna priorità e monitora lo stato di avanzamento.",
      },
      tenants: {
        title: "Aziende",
      },
      sensors: {
        title: "Sensori",
      },
      profile: {
        welcome: "Benvenuto",
        title: "Profilo",
        today: "Oggi è",
        lastLogin: "Ultimo accesso",
      },
      lastAudits: {
        title: "Registro",
        date: "Data e ora",
        user: "Name",
        description: "Descrizione",
        has: "ha",
        action: {
          configurePermissions: "configurato permessi",
          create: "creato",
          update: "modificato",
          delete: "cancellato",
          status: "spostato",
          message: "commentato",
          copy: "copiato",
          "add-task": "aggiunto task",
          "update-task": "aggiornato task",
          upload: "caricato documento",
        },
      },
      tickets: {
        title: "Tickets",
        performance: "Performance",
        performanceNotAvailable: "Statistiche non disponibili",
      },
      tasks: {
        title: "Attività",
      },
      assets: {
        title: "Assets",
      },
    },
    assets: {
      title: "Assets",
      documents: "Documenti",
      tickets: "Tickets",
      tasks: "Attività",
      notFound: "Asset non trovato",
      noSearchResults: "Nessun asset corrisponde alla ricerca",
      confirmDrop: {
        title: "Conferma spostamento",
        text: "Sei sicuro di voler spostare l'asset %name% all'interno di %target%?",
        textNoParent: "Sei sicuro di voler spostare l'asset %name%?",
        dropRoot: "Rilascia qui per spostare alla radice",
        confirm: "Sposta",
      },
    },
    archive: {
      sensor: "Sensore",
      from: "Inizio",
      to: "Fine",
      chart: "Grafico",
      table: "Tabella",
      date: "Data",
      hour: "Ora",
      value: "Valore",
      all: "Tutti",
      filters: "Filtri",
    },
    prognosis: {
      asset: "Asset",
      from: "Inizio",
      to: "Fine",
      chart: "Grafico",
      table: "Tabella",
    },
    users: {
      tab1: "Utenti",
      tab2: "Gruppi",
      editCredentials: "Credenziali",
      detail: "Dettaglio utente",
      showDetail: "Dettaglio",
      notFound: "Utente non trovato o non consultabile",
      artifactTasks: "Task di produzione",
      noArtifactTasks: "Nessun task di produzione assegnato",
      delete: {
        user: "Confermare l'eliminazione dell'utente dal gruppo?",
        group: "Confermare l'eliminazione del gruppo?",
      },
    },
    audits: {
      filterByType: "Filtra per tipo",
    },
    documents: {
      search: "Cerca",
      creationDate: "Data",
      uploadedBy: "Caricato da",
      noDocuments: "Nessun documento trovato",
      category: "Categoria",
      resetFilter: "Cancella filtri",
      file: "File",
      addFile: "Aggiungi file",
      addFileDescription: "I file saranno salvati in:",
      delete: "Elimina",
      tag: "Tag",
      view: {
        folders: "Cartelle",
        table: "Lista",
      },
      open: "Apri",
      download: "Scarica",
      goTo: {
        asset: "Vai all'asset",
        task: "Vai all'attività",
        ticket: "Vai al ticket",
        artifact: "Vai alla produzione",
      },
      folders: {
        assets: "Asset",
        artifacts: "Produzioni",
        other: "Varie",
      },
      rootFolder: "Cartella radice",
      location: "Posizione",
      selectAll: "Seleziona tutti",
      selected: "selezionati",
    },
    artifacts: {
      hour: "Oraria",
      quarterDay: "Quarto di giorno",
      halfDay: "Mezza giornata",
      day: "Giorno",
      week: "Settimana",
      month: "Mese",
      qyear: "Quadrimestre",
      year: "Anno",
      zoomIn: "Ingrandisci",
      zoomOut: "Rimpicciolisci",
      hideTable: "Nascondi tabella",
      showTable: "Mostra tabella",
      from: "Inizio",
      to: "Fine",
      assignee: "Assegnato a",
      duration: "Durata",
      days: "giorni",
      progress: "Stato",
      dependencies: "Dipendenze",
      view: {
        gantt: "Gantt",
        table: "tabellare",
      },
      editTask: {
        new: "Nuova attività",
        edit: "Modifica attività",
        editDescription: "Modifica i dati dell'attività %name%",
        newDescription: "Aggiungi una nuova sotto attività a %name%",
        name: "Nome",
        description: "Descrizione",
        assignee: "Assegnatario",
        asset: "Asset",
        start: "Data inizio",
        end: "Data fine",
      },
      deleteTask: {
        title: "Elimina attività",
        text: "Sei sicuro di voler eliminare l'attività %name%?",
        confirm: "Elimina",
      },
      changeTaskDates: {
        title: "Modifica date",
        text: "Vuoi impostare l'attività %name% dal %start% al %end%?",
        confirm: "Modifica",
      },
      assigned: {
        empty: "Non hai task assegnati.",
        fill: "Compila",
        noChecklist: "Nessuna checklist",
        artifactProgress: "Produzione completa al %progress%%",
      },
      answer: {
        text: "Risposta",
        select: "Seleziona",
        none: "Nessuna",
        attachment: "Allegato",
        upload: "Allega file",
        read: "Ho letto e compreso",
        completed: "%done% di %total% step completati",
      },
      checklist: {
        title: "Checklist",
        description:
          "Definisci gli step che l'assegnatario dell'attività %name% dovrà completare",
        empty: "Nessuno step: aggiungine uno per iniziare.",
        addStep: "Aggiungi step",
        question: "Domanda",
        readText: "Testo da leggere",
        options: "Opzioni",
        optionsRequired: "Inserisci almeno un'opzione",
        moveUp: "Sposta su",
        moveDown: "Sposta giù",
        type: {
          label: "Tipo",
          TEXT: "Testo libero",
          SINGLE_CHOICE: "Risposta singola",
          MULTIPLE_CHOICE: "Risposta multipla",
          SELECT: "Selezione da tendina",
          FILE: "Allegato",
          READ: "Lettura",
        },
      },
    },
    goods: {
      recycle: {
        title: "Smaltisci",
        step0: "Seleziona il dpp",
        step1: "Seleziona l'azienda di smaltimento",
        step2: "Inserisci l'indirizzo di ritiro",
        step3: "Conferma la richiesta di smaltimento",
        confirm: "Conferma",
        confirmText:
          "Cliccando su conferma verrà inviata una mail con i dati inseriti all'azienda di smaltimento selezionata",
        address: "Indirizzo",
      },
    },
    admin: {
      tenant: "Azienda",
      chatbot: "Chatbot",
    },
  },
  entity: {
    tenant: {
      title: "Azienda",
      name: "Nome",
      email: "Email",
      img: "Immagine",
      primaryColor: "Colore primario",
      secondaryColor: "Colore secondario",
      menu: "Menu",
      users: "Utenti",
      diskUsage: "Spazio usato",
      alertThreshold: "Allarme soglia",
      alertSilence: "Allarme silenzio",
    },
    user: {
      title: "Utente",
      name: "Nome",
      surname: "Cognome",
      username: "Username",
      role: "Ruolo",
      password: "Password",
      avatar: "Avatar",
      email: "Email",
      phone: "Telefono",
      img: "Foto",
      lastLogin: "Ultimo accesso",
    },
    group: {
      title: "gruppo",
    },
    asset: {
      title: "Asset",
      type: "Tipo",
      name: "Nome",
      description: "Descrizione",
      location: "Luogo",
      status: "Stato",
      start: "Inizio",
      end: "Fine",
      img: "Immagine",
      metadata: "Metadata",
      assignee: "Responsabile",
      sensor_scalar: "Sensore scalare",
      sensor_multivalue: "Sensore multivalore",
      building: "Edificio",
      production: "Produzione",
      product: "Prodotto",
      machine: "Macchinario",
      vehicle: "Veicolo",
      installationDate: "Data di installazione",
      estimatedEndDate: "Data di fine stimata",
    },
    building: {
      title: "edificio",
    },
    machine: {
      title: "macchinario",
    },
    sensorscalar: {
      title: "sensore scalare",
    },
    sensormultivalue: {
      title: "sensore multivalore",
    },
    production: {
      title: "produzione",
    },
    vehicle: {
      title: "veicolo",
    },
    product: {
      title: "prodotto",
    },
    task: {
      title: "Attività",
      name: "Nome",
      description: "Descrizione",
      assignee: "Responsabile",
      asset: "Asset",
      start: "Inizio",
      end: "Fine",
      recurring: "Ricorrente",
      recurrenceRule: "Regola ricorrenza",
      recurrenceEnd: "Fine ricorrenza",
      daily: "Giornaliera",
      weekly: "Settimanale",
      monthly: "Mensile",
      tags: "Tags",
    },
    ticket: {
      title: "Ticket",
      createdAt: "Creato il",
      name: "Titolo",
      description: "Descrizione",
      assignee: "Responsabile",
      asset: "Asset",
      status: "Stato",
      ip: "In corso",
      todo: "Da fare",
      done: "Completato",
      user: "Utente",
      updatedAt: "Data modifica",
      reporter: "Creato da",
      info: "Info",
      messages: "Messaggi",
      noMessages: "Nessun messaggio",
      unassigned: "Non assegnato",
      untagged: "Non taggato",
      priority: {
        label: "Priorità",
        0: "Bassa",
        1: "Media",
        2: "Alta",
      },
      tags: "Tags",
    },
    sensor: {
      title: "Sensore",
      name: "Nome",
      type: "Tipo",
      color: "Colore",
      thresholdMin: "Soglia minima",
      thresholdMax: "Soglia massima",
      min: "Valore minimo",
      max: "Valore massimo",
      scalar: "Scalare",
      multivalue: "Multivalore",
      columns: "Colonne",
      focus: "Focus",
      filters: "Filtri",
      valueFilter: {
        header: "Filtri sui valori",
        add: "Aggiungi filtro",
        values: "Valori",
        column: "Colonna",
      },
    },
    measure: {
      title: "Misurazione",
    },
    document: {
      title: "Documento",
    },
    diagnosis: {
      title: "Diagnosi",
      healthIndex: "Health Index",
      prevalentState: "Stato Prevalente",
      severity: "Severità Media",
      timestamp: "Data",
    },
    prognosis: {
      title: "Prognosi",
      rul: "RUL (Ore)",
      failureDate: "Data Guasto Stimata",
      failureProbability: "Probabilità Guasto",
      timestamp: "Data",
      noData: "Nessun dato",
    },
    artifact: {
      title: "Produzione",
      name: "Nome",
      description: "Descrizione",
      assignee: "Responsabile",
      asset: "Asset",
      start: "Inizio",
      end: "Fine",
      img: "Immagine",
      progress: "Completamento",
    },
    tag: {
      title: "Tag",
      key: "Chiave",
      label: "Etichetta",
      description: "Descrizione",
      color: "Colore",
    },
    goods: {
      title: "Rifiuti",
      name: "Nome",
      description: "Descrizione",
      img: "Immagine",
      recycled: "Smaltito",
      category: "Categoria",
      category1: "Rifiuti non pericolosi",
      category2: "Rifiuti pericolosi",
      category3: "RAEE",
      category4: "Rifiuti sanitari",
      category5: "Rifiuti da costruzione e demolizione",
      category6: "Rifiuti industriali",
      category7: "Rifiuti agricoli",
    },
    call: {
      title: "Chiamata",
      caller: "Chiamante",
      callee: "Chiamato",
      startedAt: "Inizio",
      endedAt: "Fine",
      duration: "Durata",
      outcome: {
        label: "Esito",
        all: "Tutti",
        completed: "Completata",
        missed: "Persa",
        rejected: "Rifiutata",
      },
      summary: "Riepilogo",
    },
  },
  userActions: {
    settings: "Impostazioni",
    logout: "Esci",
    light: "Chiaro",
    dark: "Scuro",
    system: "Sistema",
    language: "Lingua",
    theme: "Tema",
    logoutDialog: {
      title: "Conferma Logout",
      text: "Sei sicuro di voler terminare la sessione corrente ed uscire?",
      exit: "Esci",
      cancel: "Annulla",
    },
    search: {
      title: "Cerca",
      placeholder: "Cerca...",
      button: "Cerca",
      type: {
        asset: "Asset",
        document: "Documento",
        task: "Attività",
        ticket: "Ticket",
        artifact: "Produzione",
      },
    },
  },
  notifications: {
    title: "Notifiche",
    empty: "Nessuna notifica",
    "task-created": "Nuova attività",
    "task-updated": "Attività aggiornata",
    "ticket-created": "Nuovo ticket",
    "ticket-message": "Nuovo messaggio",
    "ticket-updated": "Ticket aggiornato",
    "ticket-status-updated": "Ticket spostato",
    prognosis: "Nuova prognosi",
    diagnosis: "Nuova diagnosi",
  },
  permissions: {
    title: "Configura permessi",
    description:
      "Seleziona un elemento dal catalogo di dati e configura i permessi da associare alla selezione",
    table: {
      title: "Configura permessi",
      groupUser: "Gruppo/Utente",
      canView: "Può visualizzare",
      canEdit: "Può modificare",
      canDelete: "Può eliminare",
    },
  },
  chatbot: {
    title: "Assistente",
    open: "Apri la chat",
    close: "Chiudi la chat",
    new: "Nuova conversazione",
    empty: "Chiedi qualcosa all'assistente",
    placeholder: "Scrivi un messaggio",
    send: "Invia",
    provider: "Provider",
    model: "Modello",
    assistant: "Assistente",
    noProviders: "Nessun modello disponibile",
    configure: "Configura il chatbot",
    notConfiguredAdmin: "Configura chiave e modello nella pagina Chatbot",
    notConfigured: "Il chatbot non è configurato, contatta l'amministratore.",
    selectTenant: "Seleziona un'azienda per usare il chatbot.",
    error: {
      default: "Impossibile completare la richiesta",
      unavailable: "Provider non configurato: manca la chiave",
      rejected: "Il provider ha rifiutato la chiave",
      rateLimit: "Troppe richieste, riprova tra poco",
      selectTenant: "Seleziona un tenant per usare il chatbot.",
      disabled: "Il chatbot è disattivato per questo tenant.",
    },
    suggestions: {
      title: "Cose da fare",
      checklist: {
        one: "task con checklist da completare",
        other: "task con checklist da completare",
        prompt: "Compiliamo la checklist",
      },
      myTickets: {
        one: "ticket assegnato a te",
        other: "ticket assegnati a te",
        prompt: "Quali ticket ho assegnati?",
      },
    },
    choices: {
      send: "Invia",
    },
    action: {
      confirm: "Conferma",
      cancel: "Annulla",
      done: "Eseguita",
      failed: "Non eseguita",
      cancelled: "Annullata",
      superseded: "Sostituita da una proposta più recente",
      cancelledMessage: "Azione annullata",
    },
    settings: {
      title: "Impostazioni chatbot",
      enabled: "Chatbot attivo",
      apiKey: "Chiave API",
      showKey: "Mostra chiave",
      hideKey: "Nascondi chiave",
      models: {
        loading: "Caricamento modelli",
        missingKey: "Salva prima la chiave di questo provider.",
        error: "Impossibile caricare i modelli",
      },
      documents: {
        title: "Documenti",
        hint: "Il chatbot usa i documenti caricati in PrediMain e si aggiorna da solo.",
        reindex: "Reindicizza ora",
        indexedOne: "indicizzato",
        indexedMany: "indicizzati",
        skippedOne: "ignorato",
        skippedMany: "ignorati",
        failedOne: "fallito",
        failedMany: "falliti",
        embedding: "Servizio di embedding non configurato",
      },
    },
  },
  error: {
    0: "Si è verificato un errore",
    101: "Il contenuto richiesto non esiste",
    105: "Azione non consentita",
    401: "Autenticazione fallita",
    500: "Impossibile completare l'operazione",
    forbidden: {
      title: "Accesso negato",
      text: "Non hai il permesso per visualizzare questa risorsa.",
      back: "Torna alla home",
    },
    sessionExpired: "Sessione scaduta",
    validation: {
      required: "Campo obbligatorio",
      duplicate: "Valore già presente",
      endDateAfterStartDate:
        "La data di fine deve essere successiva alla data di inizio",
      type: {
        number: "Il campo deve essere un numero",
      },
    },
  },
};

export default it;
